import { AlertCircle, MessageCircle, ArrowRight } from 'lucide-react';
import { ContratacaoPublicShell } from '@/components/contratacao/ContratacaoPublicShell';

function getMainAppUrl(): string {
  const raw = import.meta.env.VITE_MAIN_APP_URL?.trim();
  if (!raw) return 'https://app.imobdesk.com.br';
  return raw.replace(/\/$/, '');
}

export default function Erro() {
  const mainAppUrl = getMainAppUrl();

  return (
    <ContratacaoPublicShell innerClassName="flex flex-col items-center text-center py-6 sm:py-8">
      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-amber-50">
        <AlertCircle className="h-9 w-9 text-amber-600" aria-hidden />
      </div>
      <h1 className="h-step mt-6">Estamos quase lá</h1>
      <p className="t-step mb-8">
        O pagamento não foi concluído ou houve uma interrupção. Nosso time pode te ajudar a finalizar a
        contratação.
      </p>
      <div className="flex w-full max-w-sm flex-col gap-3">
        <button
          type="button"
          className="cta cta--indigo"
          onClick={() =>
            window.open(
              'https://wa.me/5511999999999?text=Olá! Tive um problema durante o checkout.',
              '_blank',
            )
          }
        >
          <MessageCircle className="h-5 w-5" />
          Falar com suporte
        </button>
        <button
          type="button"
          className="inline-flex h-14 w-full items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white text-base font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
          onClick={() => {
            window.location.href = mainAppUrl;
          }}
        >
          Ir para o login
          <ArrowRight className="h-5 w-5 text-slate-500" />
        </button>
      </div>
    </ContratacaoPublicShell>
  );
}
